import { render, staticRenderFns } from "./IndexPageCardDesignSection.vue?vue&type=template&id=97db7dae&"
import script from "./IndexPageCardDesignSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageCardDesignSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports